export default __webpack_public_path__ + "static/media/categories-arrow.e27381b3.svg";